<template>
  <touch-layout :page_override_class="{ 'trade-designer-choose-product': true }">
    <template #header_page_breadcrumb>
      <Breadcrumbs
        :routes="[
          ['Dashboard', '/'],
          ['Customer Management', '/customer'],
          ['Sales Dashboard', '/customer/' + customer.customerId + '/sales-dashboard'],
          ['Choose Product'],
          [selectedProductName],
        ]"
      />
    </template>
    <template #site_header_actions_wrapper>
      <div v-if="selectedProductName" class="flex border-b flex-1 h-full">
        <div
          v-if="$refs.chooseProduct"
          class="flex flex-row flex-wrap bg-white md:px-5 border-t-4 border-white h-full"
        >
          <div
            class="cursor-pointer border-b-4 py-2 px-1 mx-3 md:mx-5 hover:border-black mt-auto"
            :class="{ 'border-black': !stock_parts_mode, 'border-white': stock_parts_mode }"
            @click="$refs.chooseProduct.setMode('products')"
          >
            Products
          </div>
          <div
            class="cursor-pointer border-b-4 py-2 px-1 mx-3 md:mx-5 hover:border-black mt-auto"
            :class="{ 'border-black': stock_parts_mode, 'border-white': !stock_parts_mode }"
            @click="stockPartsStore.license?.status ? $refs.chooseProduct.setMode('stock-parts') : store()"
          >
            Stock Parts
          </div>
        </div>
      </div>
    </template>
    <ChooseProduct
      ref="chooseProduct"
      :customer="customer"
      :url="url"
      @selected-product-name="selectedProductName = $event"
      @set-stock-parts="stock_parts_mode = $event"
    />
  </touch-layout>
</template>

<script>
import ChooseProduct from '@/components/shared/chooseProduct/ChooseProduct.vue';
import Breadcrumbs from '@/components/shared/Breadcrumbs.vue';
import { mapStores } from 'pinia'
import { useStockPartsStore } from '@/pinia/stock-parts';
import { useBasketStore } from '@/pinia/basket';

export default {
  components: {
    ChooseProduct,
    Breadcrumbs,
  },
  props: {
    customer: Object,
  },
  data() {
    return {
      customerId: undefined,
      selectedProductName: undefined,
      stock_parts_mode: false,
      url: undefined,
    };
  },
  computed: {
    ...mapStores(useStockPartsStore, useBasketStore),
  },
  async created() {
    const OneDay = new Date().getTime() + (1 * 24 * 60 * 60 * 1000)
    if ((typeof this.stockPartsStore.license.lastChecked === 'undefined') || new Date(this.stockPartsStore.license.lastChecked) < OneDay) {
      const STOCK_PARTS_LICENSE = 30
      const { data } = await window.touch.isProductAvailable(STOCK_PARTS_LICENSE);
      this.stockPartsStore.license.status = data.available
      this.stockPartsStore.license.lastChecked = new Date()
    }
    this.url = `/customer/${this.basketStore.customerId}/sales-dashboard`
  },
  methods: {
    store() {
      this.alertBox().fire({
        title: 'License Required',
        html: ' Please contact <a class="text-blue-600" href="mailto:sales@bm-touch.co.uk">sales@bm-touch.co.uk</a> to enable stock parts processing.',
      });
    }
  },
};
</script>
